import { updatePropertyObject } from '../../../common';
export const updateStylePropertiesObject = (component, newProperties) => {
  const {
    style
  } = component;
  const properties = style == null ? void 0 : style.style.properties;
  if (properties) {
    style.style.properties = updatePropertyObject(properties, newProperties);
  }
  return {
    ...component,
    style
  };
};
//# sourceMappingURL=update-style-properties-object.js.map